export const METRICS = {
  NUMBER_OF_PAYMENTS: 'numberOfPayments',
  NUMBER_OF_SUBSCRIPTIONS: 'numberOfSubscriptions',
  NUMBER_OF_SUBMISSIONS: 'numberOfSubmissions',
  REVENUE: 'revenue',
  NUMBER_OF_CUSTOMERS: 'numberOfCustomers',
  NUMBER_OF_VISITS: 'numberOfVisits',
  ACTIVE_SUBSCRIBERS: 'activeSubscribers',
  RECURRING_REVENUE: 'recurringRevenue',
};
